import React, { useEffect, useState } from 'react';
import { Container, Typography, InputLabel, Paper, Divider, Button, Grid, CircularProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { ShopActions, NotificationActions } from '../../../store';
import ShopEntryStep1 from './ShopEntryStep1';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px'
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const shopsSelector = (state) => state.Shops;
const IdentitySelector = (state) => state.Identity;

const ShopUpdate = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const shopActions = bindActionCreators(ShopActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(shopsSelector);
    const { token } = useSelector(IdentitySelector);

    const { classes } = props;

    /**
     *
     * 戻る押下時の処理
     *
     */
    const handleBack = (data) => {
        // 対象の加盟店IDの加盟店情報を取得
        shopActions.loadEditModel(token, editing.id)
            .then(data => {
                // 詳細画面に戻る
                props.onCancel();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    };

    /**
     *
     * 保存ボタン押下時の処理（更新時）
     *
     */
    const handleUpdate = (data) => {
        // 編集した店舗情報を保存
        shopActions.save(token, editing)
            .then(data => {
                // メッセージ表示＆詳細画面に戻る
                props.onUpdate();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    };

    /**
     *
     * 画面切替
     *
     */
    const getStepContent = (index) => {
        switch (index) {
            case '0':
                // 店舗情報入力画面
                return <ShopEntryStep1 handleNext={handleUpdate} handleBack={handleBack} mode="update" />
            default:
                return 'Unknown stepIndex';
        }
    }

    /**
     *
     * 画面のタイトル
     *
     */
    const getTitle = (index) => {
        switch (index) {
            case '0':
                // 店舗情報編集
                return <FormattedMessage id="Shop.EditTitle" />
            default:
                return 'Unknown Title';
        }
    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Grid container className={classes.form} spacing={2}>
                    <Grid item xs={12}>
                        <Typography component="h1" variant="inherit">{getTitle(props.intIndex)}</Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel component="legend">{<FormattedMessage id="Shop.EditDesc" />}</InputLabel>
                    </Grid>
                </Grid>
                {getStepContent(props.intIndex)}
            </Paper>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(ShopUpdate);
